module.exports = __webpack_public_path__ + "img/avad_yes.764dd366.png";